import { render } from "./h5SelectStore.vue?vue&type=template&id=2dec39fb&scoped=true"
import script from "./h5SelectStore.vue?vue&type=script&lang=js"
export * from "./h5SelectStore.vue?vue&type=script&lang=js"

import "./h5SelectStore.vue?vue&type=style&index=0&id=2dec39fb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dec39fb"]])

export default __exports__